/****************************************************
 * Module Name:  designationProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class DesignationProxy {
  static GetAllDesignation = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/designation",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleDesignation = (DesignationId, callback) => {
    let params = {
      id: DesignationId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/designation",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckDesignationAvailable = (designation, callback) => {
    let params = {
      designation: designation,
    };

    restAPICall(
      Constants.MANAGER_URL + "/designation/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddDesignation = (designation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/designation",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(designation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateDesignation = (designation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/designation",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(designation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteDesignation = (designation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/designation",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(designation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
